/* Produktseite: Akkordeon "Nährwerte, Zutaten, Einnahme, Analysen" (sections/accordion-content.liquid).
   1) Es ist immer nur ein Block offen.
   2) Button "Prüfberichte ansehen" in der Transparenz-Karte öffnet den Analysen-Block.
   3) Im Quelltext stehen nur die Angaben der gewählten Sorte, beim Sortenwechsel werden sie nachgeladen. */
(function () {
  /* nur das Produkt-Akkordeon (Attribut setzt die Section), nicht die FAQ-Sections mit derselben Klasse */
  var SECTION = '[data-akkordeon-einzeln]';
  var HEADER_OFFSET = 120; /* fester Header: darunter gilt eine Zeile als verdeckt */

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scrollTo(target) {
    target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
  }

  /* 1) Öffnet sich ein Block, schließen die anderen derselben Section.
        "toggle" steigt nicht auf, deshalb in der Capture-Phase abfangen. Es feuert bei jedem Öffnen,
        egal ob per Klick, über die Pille im Produktbild oder über den Button in der Karte. */
  document.addEventListener('toggle', function (event) {
    var opened = event.target;
    if (!opened || !opened.matches || !opened.matches(SECTION + ' details.accordion') || !opened.open) { return; }

    var section = opened.closest(SECTION);
    var others = section.querySelectorAll('details.accordion');
    for (var i = 0; i < others.length; i++) {
      if (others[i] !== opened && others[i].open) { others[i].open = false; }
    }

    /* Schließt darüber ein langer Block, rutscht die geöffnete Zeile nach oben aus dem Bild: dann nachscrollen */
    window.setTimeout(function () {
      if (opened.open && opened.getBoundingClientRect().top < HEADER_OFFSET) { scrollTo(opened); }
    }, 450);
  }, true);

  /* 2) Button in der Transparenz-Karte */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-open-analysen]');
    if (!button) { return; }
    /* per Tastatur ausgelöst (detail 0): Fokus mitnehmen. Bei Maus/Touch nicht, sonst erscheint ein Fokusrahmen. */
    var viaKeyboard = event.detail === 0;

    var section = button.closest('.shopify-section');
    var target = section ? section.querySelector('details.analysen') : null;
    if (!target) { return; }

    var summary = target.querySelector('summary');
    if (!target.open) {
      if (summary) { summary.click(); } else { target.open = true; }
    }

    /* warten, bis auf- und zugeklappt ist, dann nur scrollen, wenn der Block nicht schon im Bild ist */
    window.setTimeout(function () {
      var top = target.getBoundingClientRect().top;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      if (top < HEADER_OFFSET || top > viewportHeight * 0.6) { scrollTo(target); }
      if (summary && viaKeyboard) { summary.focus({ preventScroll: true }); }
    }, 500);
  });

  /* 3) Sortenwechsel: Section für die neue Sorte holen (Section Rendering API) und die Bereiche
        [data-akk-inhalt] austauschen. Solange geladen wird, sind die alten Angaben abgeblendet;
        schlägt das Laden fehl, verschwinden sie ganz. Es bleiben nie Zutaten einer anderen Sorte stehen. */
  var sectionCache = {};

  function loadSection(root, variantId) {
    var key = root.getAttribute('data-akk-section') + ':' + variantId;
    if (!sectionCache[key]) {
      var url = root.getAttribute('data-akk-url') + '?variant=' + encodeURIComponent(variantId) +
        '&section_id=' + encodeURIComponent(root.getAttribute('data-akk-section'));
      var controller = window.AbortController ? new AbortController() : null;
      var timer = window.setTimeout(function () { if (controller) { controller.abort(); } }, 10000);
      sectionCache[key] = fetch(url, { credentials: 'same-origin', signal: controller ? controller.signal : undefined })
        .then(function (response) {
          if (!response.ok) { throw new Error('HTTP ' + response.status); }
          return response.text();
        })
        .then(function (html) {
          window.clearTimeout(timer);
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-akk-variante="' + variantId + '"]');
          if (!fresh) { throw new Error('Sorte fehlt in der Antwort'); }
          return fresh;
        })
        .catch(function (error) {
          window.clearTimeout(timer);
          delete sectionCache[key]; /* beim nächsten Wechsel neu versuchen */
          throw error;
        });
    }
    return sectionCache[key];
  }

  function areas(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-akk-inhalt]'));
  }

  function setLeer(details, leer) {
    if (!details) { return; }
    details.style.display = ''; /* Inline-Wert aus dem alten Sortenwechsel-Code zurücknehmen, es gilt die Klasse */
    details.classList.toggle('akk-leer', leer);
    if (leer && details.open) { details.open = false; }
  }

  function applySection(root, fresh, variantId) {
    areas(root).forEach(function (target) {
      var source = fresh.querySelector('[data-akk-inhalt="' + target.getAttribute('data-akk-inhalt') + '"]');
      target.innerHTML = source ? source.innerHTML : '';
      target.removeAttribute('aria-busy');
      var sourceDetails = source ? source.closest('details.accordion') : null;
      setLeer(target.closest('details.accordion'), !sourceDetails || sourceDetails.classList.contains('akk-leer'));
    });
    root.setAttribute('data-akk-variante', variantId);
  }

  function showError(root, variantId) {
    areas(root).forEach(function (target) {
      target.removeAttribute('aria-busy');
      target.textContent = '';
      var note = document.createElement('p');
      note.className = 'akk-fehler';
      note.appendChild(document.createTextNode('Die Angaben für diese Sorte konnten gerade nicht geladen werden. '));
      var link = document.createElement('a');
      link.href = root.getAttribute('data-akk-url') + '?variant=' + encodeURIComponent(variantId);
      link.textContent = 'Seite neu laden';
      note.appendChild(link);
      target.appendChild(note);
      setLeer(target.closest('details.accordion'), false);
    });
    root.setAttribute('data-akk-variante', '');
  }

  document.addEventListener('variant:change', function (event) {
    var detail = event.detail || {};
    if (!detail.variant || !detail.product) { return; }
    var variantId = String(detail.variant.id);

    var roots = document.querySelectorAll('[data-akk-section][data-akk-product="' + detail.product.id + '"]');
    Array.prototype.forEach.call(roots, function (root) {
      root.akkGewuenscht = variantId; /* bei schnellem Durchklicken zählt nur die letzte Sorte */
      if (root.getAttribute('data-akk-variante') === variantId) {
        areas(root).forEach(function (target) { target.removeAttribute('aria-busy'); });
        return;
      }
      areas(root).forEach(function (target) { target.setAttribute('aria-busy', 'true'); });
      loadSection(root, variantId).then(function (fresh) {
        if (root.akkGewuenscht === variantId) { applySection(root, fresh, variantId); }
      }).catch(function () {
        if (root.akkGewuenscht === variantId) { showError(root, variantId); }
      });
    });
  });
})();
